import type { ListTableBatchButtonsProps } from "./list-table-batch-buttons.type";
import type { ListItem } from "@/modules/list";

import {
  DeleteOutlined,
  DisconnectOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useListContext } from "@/modules/list";

import { isBatchModeActive } from "./list-table-batch-buttons.helper";

const ListTableBatchButtons = <Item extends ListItem = ListItem>({
  selectedItems,
  onBatchEditClick,
  onBatchDeleteClick,
  onBatchDissociateClick,
  divider,
}: ListTableBatchButtonsProps<Item>) => {
  const { t } = useTranslation();
  const { loading } = useListContext<Item>();

  const isBatchMode = isBatchModeActive<Item>({
    onBatchEditClick,
    onBatchDeleteClick,
    onBatchDissociateClick,
  });

  if (!isBatchMode || !selectedItems.length) return null;

  return (
    <>
      {divider}
      {onBatchEditClick && (
        <Button
          icon={<EditOutlined />}
          onClick={() => onBatchEditClick(selectedItems)}
          disabled={loading}
        >
          {t("global:batchEdit.label")}
        </Button>
      )}
      {onBatchDissociateClick && (
        <Button
          icon={<DisconnectOutlined />}
          onClick={() => onBatchDissociateClick(selectedItems)}
          disabled={loading}
        >
          {t("global:batchDissociate")}
        </Button>
      )}
      {onBatchDeleteClick && (
        <Button
          icon={<DeleteOutlined />}
          onClick={() => onBatchDeleteClick(selectedItems)}
          disabled={loading}
          danger
        >
          {t("global:batchDelete.label")}
        </Button>
      )}
    </>
  );
};

export default ListTableBatchButtons;
